import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import { route } from "./../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import { useNavigate, useParams } from "react-router-dom";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import ImgInputLarge from "../../../component/atoms/input/imgInputLarge";
import ImgPreviewLarge from "../../../component/molecules/imgPreviewLarge";
import ProductApi from "../../../api/product.api";
import { fileUrl } from "../../../api/api";
import FileApi from "../../../api/file.api";

// TODO:

const ShoppingProductEditImage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getProductData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 데이터 관련 ---------- //
  const [productData, setProductData] = useState({});

  const getProductData = async () => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;

      setProductData(response);
      setImageObj({
        ...imageObj,
        thumbnailFileName: response.thumbnailOriginFileName,
        bannerFileName: response.bannerOriginFileName,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 썸네일 및 배너 설정 ---------- //
  // 이미지 추가, 삭제
  const [imageObj, setImageObj] = useState({
    thumbnailFile: null,
    thumbnailFileUrl: null,
    thumbnailFileName: null,
    bannerFile: null,
    bannerFileUrl: null,
    bannerFileName: null,
  });

  const inputFile = (e, type) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    if (type === "thumbnail") {
      fileReader.onload = (value) => {
        setImageObj({
          ...imageObj,
          thumbnailFile: file,
          thumbnailFileUrl: value.target.result,
          thumbnailFileName: file.name,
        });
      };
    }

    if (type === "banner") {
      fileReader.onload = (value) => {
        setImageObj({
          ...imageObj,
          bannerFile: file,
          bannerFileUrl: value.target.result,
          bannerFileName: file.name,
        });
      };
    }
    e.target.value = "";
  };

  const deleteFile = (type) => {
    if (type === "thumbnail") {
      setImageObj({
        ...imageObj,
        thumbnailFile: null,
        thumbnailFileUrl: null,
        thumbnailFileName: null,
      });
    } else if (type === "banner") {
      setImageObj({
        ...imageObj,
        bannerFile: null,
        bannerFileUrl: null,
        bannerFileName: null,
      });
    }
  };

  // ---------- 다음 단계로 이동 ---------- //
  const handleNextStep = async () => {
    if (!imageObj.thumbnailFileName) {
      toast("썸네일 이미지를 등록해주세요.");
      return;
    } else if (!imageObj.bannerFileName) {
      toast("배너 이미지를 등록해주세요.");
      return;
    }

    try {
      if (imageObj.thumbnailFile && imageObj.bannerFile) {
        const thumbnailResponse = await FileApi.fileUpload(
          imageObj.thumbnailFile,
          "admin/product"
        );
        const bannerResponse = await FileApi.fileUpload(
          imageObj.bannerFile,
          "admin/product"
        );
        const data = {
          ...productData,
          thumbnailOriginFileName: imageObj.thumbnailFile.name,
          thumbnailServerFileName: thumbnailResponse.data.data.serverFileName,
          bannerOriginFileName: imageObj.bannerFile.name,
          bannerServerFileName: bannerResponse.data.data.serverFileName,
        };
        await ProductApi.updateProduct(id, data);
      } else if (imageObj.thumbnailFile && !imageObj.bannerFile) {
        const thumbnailResponse = await FileApi.fileUpload(
          imageObj.thumbnailFile,
          "admin/product"
        );
        const data = {
          ...productData,
          thumbnailOriginFileName: imageObj.thumbnailFile.name,
          thumbnailServerFileName: thumbnailResponse.data.data.serverFileName,
        };
        await ProductApi.updateProduct(id, data);
      } else if (!imageObj.thumbnailFile && imageObj.bannerFile) {
        const bannerResponse = await FileApi.fileUpload(
          imageObj.bannerFile,
          "admin/product"
        );
        const data = {
          ...productData,
          bannerOriginFileName: imageObj.bannerFile.name,
          bannerServerFileName: bannerResponse.data.data.serverFileName,
        };
        await ProductApi.updateProduct(id, data);
      }
      navigate(`${route.shopping_product_edit_etc}/${id}`);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 수정">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  selected={item === pageTitleList[3]}
                  onClick={() => {
                    if (item === pageTitleList[0]) {
                      navigate(`${route.shopping_product_edit_basic}/${id}`);
                    } else if (item === pageTitleList[1]) {
                      navigate(`${route.shopping_product_edit_detail}/${id}`);
                    } else if (item === pageTitleList[2]) {
                      navigate(`${route.shopping_product_edit_chapter}/${id}`);
                    } else if (item === pageTitleList[3]) {
                      return;
                    } else if (item === pageTitleList[4]) {
                      navigate(`${route.shopping_product_edit_etc}/${id}`);
                    } else {
                      return;
                    }
                  }}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[3]}</TableTitle>

          {/* 썸네일 등록 영역 */}
          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "12px",
            }}
          >
            썸네일 등록
          </PretendardText>
          {productData.thumbnailServerFileName && (
            <ImgPreviewLarge
              fileUrl={`${fileUrl}/${productData.thumbnailServerFileName}`}
              onClick={() => {
                setProductData({
                  ...productData,
                  thumbnailOriginFileName: "",
                  thumbnailServerFileName: "",
                });
                setImageObj({
                  ...imageObj,
                  thumbnailFile: null,
                  thumbnailFileUrl: null,
                  thumbnailFileName: null,
                });
              }}
            />
          )}
          {!productData.thumbnailServerFileName &&
            imageObj.thumbnailFileUrl && (
              <ImgPreviewLarge
                fileUrl={imageObj.thumbnailFileUrl}
                onClick={() => {
                  deleteFile("thumbnail");
                }}
              />
            )}
          {!productData.thumbnailServerFileName &&
            !imageObj.thumbnailFileUrl && (
              <ImgInputLarge
                id={"thumbnailFile"}
                accept={"image/*"}
                onChange={(e) => {
                  inputFile(e, "thumbnail");
                }}
              />
            )}
          <div
            style={{
              width: "100%",
              marginTop: 12,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "rgba(181, 181, 181, 0.5)",
              }}
            >
              최적 size
            </PretendardText>
            <ul
              style={{
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "rgba(181, 181, 181, 0.5)",
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                전자책: 172*243
              </li>
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                강의/코칭·특강·자문/네트워킹 : 270*170
              </li>
            </ul>
          </div>

          <span
            style={{
              margin: "30px 0px",
              display: "block",
              height: 1,
              width: "100%",
              borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
            }}
          />

          {/* 상세페이지 상단 배너 등록 영역 */}
          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "12px",
            }}
          >
            상세페이지 상단 배너 등록
          </PretendardText>
          {productData.bannerServerFileName && (
            <ImgPreviewLarge
              fileUrl={`${fileUrl}/${productData.bannerServerFileName}`}
              onClick={() => {
                setProductData({
                  ...productData,
                  bannerOriginFileName: "",
                  bannerServerFileName: "",
                });
                setImageObj({
                  ...imageObj,
                  bannerFile: null,
                  bannerFileUrl: null,
                  bannerFileName: null,
                });
              }}
            />
          )}
          {!productData.bannerServerFileName && imageObj.bannerFileUrl && (
            <ImgPreviewLarge
              fileUrl={imageObj.bannerFileUrl}
              onClick={() => {
                deleteFile("banner");
              }}
            />
          )}
          {!productData.bannerServerFileName && !imageObj.bannerFileUrl && (
            <ImgInputLarge
              id={"bannerFile"}
              accept={"image/*"}
              onChange={(e) => {
                inputFile(e, "banner");
              }}
            />
          )}
          <div
            style={{
              width: "100%",
              marginTop: 12,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "rgba(181, 181, 181, 0.5)",
              }}
            >
              최적 size
            </PretendardText>
            <ul
              style={{
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "rgba(181, 181, 181, 0.5)",
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                760*410
              </li>
            </ul>
          </div>

          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(route.shopping_product_create_chapter);
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}

            <BasicBtn
              onClick={() => {
                handleNextStep();
              }}
            >
              다음으로
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default ShoppingProductEditImage;
